import React from 'react';
import tpl from '../templates/mobilePay';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'abank24'
        };
    }

    shouldFetchData() {
        return false;
    }
}
